<template>
	<v-container grid-list-xl>
		<v-form v-model="isAddValid">
			<v-layout row wrap>				
				<v-flex lg12>
					<v-switch label="Tender Winning Status" v-model="tenderWinning"></v-switch>
				</v-flex>
                <v-flex lg12>
                  <label class="blackLabel">* Status Description:</label>
                  <v-text-field label="Status Description" v-model="statusDescription" :rules="descriptionRules" solo single-line required></v-text-field>
                </v-flex>			
				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncAddProjectStatus()">Save</v-btn>
                        <small><strong>* The button will activate once all required fields have been completed</strong></small>
					</div>
				</div>				
			</v-layout>
		</v-form>
	</v-container>
</template>

<script>

    import { mapGetters } from 'vuex';

    export default {
        name: 'Settings',
        data () {
            return {
                isAddValid: false,
				runAdd: false,
                statusDescription: '',
                statusOrder: '',
                tenderWinning: false,
                descriptionRules: [
                    v => !!v || 'Status description is required',
                ],
                orderRules: [
                    v => !!v || 'Status order is required',
                ]
            };
        },
        methods: {
            fncAddProjectStatus() {
                this.$store.dispatch({
					type: 'fncAddProjectStatus',
					statusDescription: this.statusDescription,
					//statusOrder: this.statusOrder,
                    tenderWinning: this.tenderWinning === false ? 0 : 1
				});
			},
            fncHideModal () {
                this.$store.commit('hideModal');
            }
        },
        computed: {
            ...mapGetters([
                'objAuthorize',
				'projectStatusList'
            ])
        },
		created(){
            this.$store.dispatch('fncPopulateProjectStatusList');
		}
    }
</script>

<style scoped>
	/*@import './assets/css/shared.css'*/
</style>
